// extracted by mini-css-extract-plugin
module.exports = {"section-collapse":"section-collapse___1SPZB","highlighted":"highlighted___3hqeb","no-bottom-border":"no-bottom-border___2kUoI"};